"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ow_1 = require("ow");

var Log_1 = require("../Log");

var Phishing_1 = require("./Phishing");

var LinkSanitizer =
/*#__PURE__*/
function () {
  function LinkSanitizer(options) {
    _classCallCheck(this, LinkSanitizer);

    LinkSanitizer.Options.validate(options);
    this.options = options;
    this.baseUrl = new URL(this.options.baseUrl);
    this.topLevelsBaseDomain = this.getTopLevelBaseDomainFromBaseUrl(this.baseUrl);
  }

  _createClass(LinkSanitizer, [{
    key: "sanitizeLink",
    value: function sanitizeLink(url, urlTitle) {
      url = this.prependUnknownProtocolLink(url);
      Log_1.Log.log().debug("LinkSanitizer#sanitizeLink", {
        url: url,
        urlTitle: urlTitle
      });

      if (Phishing_1.Phishing.looksPhishy(url)) {
        Log_1.Log.log().debug("LinkSanitizer#sanitizeLink", "phishing link detected", "phishing list", url, {
          url: url,
          urlTitle: urlTitle
        });
        return false;
      }

      if (this.isPseudoLocalUrl(url, urlTitle)) {
        Log_1.Log.log().debug("LinkSanitizer#sanitizeLink", "phishing link detected", "pseudo local url", url, {
          url: url,
          urlTitle: urlTitle
        });
        return false;
      }

      return url;
    }
  }, {
    key: "getTopLevelBaseDomainFromBaseUrl",
    value: function getTopLevelBaseDomainFromBaseUrl(url) {
      var regex = /([^\s\/$.?#]+\.[^\s\/$.?#]+)$/g;
      var m = regex.exec(url.hostname);
      if (m && m[0]) return m[0];else {
        throw new Error("LinkSanitizer: could not determine top level base domain from baseUrl hostname: ".concat(url.hostname));
      }
    }
  }, {
    key: "prependUnknownProtocolLink",
    value: function prependUnknownProtocolLink(url) {
      // If this link is not relative, http, https, or steem -- add https.
      if (!/^((#)|(\/(?!\/))|(((steem|https?):)?\/\/))/.test(url)) {
        url = "https://" + url;
      }

      return url;
    }
  }, {
    key: "isPseudoLocalUrl",
    value: function isPseudoLocalUrl(url, urlTitle) {
      if (url.indexOf("#") === 0) return false;
      url = url.toLowerCase();
      urlTitle = urlTitle.toLowerCase();

      try {
        var urlTitleContainsBaseDomain = urlTitle.indexOf(this.topLevelsBaseDomain) !== -1;
        var urlContainsBaseDomain = url.indexOf(this.topLevelsBaseDomain) !== -1;

        if (urlTitleContainsBaseDomain && !urlContainsBaseDomain) {
          return true;
        }
      } catch (error) {
        if (error instanceof TypeError) {
          return false; // if url is invalid it is ok
        } else throw error;
      }

      return false;
    }
  }]);

  return LinkSanitizer;
}();

exports.LinkSanitizer = LinkSanitizer;

(function (LinkSanitizer) {
  var Options;

  (function (Options) {
    function validate(o) {
      ow_1.default(o, "LinkSanitizer.Options", ow_1.default.object);
      ow_1.default(o.baseUrl, "LinkSanitizer.Options.baseUrl", ow_1.default.string.nonEmpty);
    }

    Options.validate = validate;
  })(Options = LinkSanitizer.Options || (LinkSanitizer.Options = {}));
})(LinkSanitizer = exports.LinkSanitizer || (exports.LinkSanitizer = {}));